/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddSourcePageContainer_UserDetails_QueryVariables = {|
  id: string
|};
export type AddSourcePageContainer_UserDetails_QueryResponse = {|
  +user: ?{|
    +email: ?string,
    +is_premium: ?boolean,
    +is_active: ?boolean,
    +first_time_user: ?boolean,
  |},
  +settings: {|
    +isAuthenticated: boolean,
    +userId: ?string,
    +isNavActivated: boolean,
    +selectedSourceId: ?$ReadOnlyArray<?string>,
    +selectedParentId: ?string,
    +treeStates: ?string,
    +selectedNodeId: ?$ReadOnlyArray<?string>,
    +isParent: ?boolean,
    +sourceString: ?string,
    +categoryId: ?string,
    +isFullScreenAddSourceModalActivated: ?boolean,
    +isFullSpanSourceSearchModalActivated: ?boolean,
    +isAddSourcePageActivated: ?boolean,
    +isAddFeedBoxShown: ?boolean,
  |},
|};
export type AddSourcePageContainer_UserDetails_Query = {|
  variables: AddSourcePageContainer_UserDetails_QueryVariables,
  response: AddSourcePageContainer_UserDetails_QueryResponse,
|};
*/


/*
query AddSourcePageContainer_UserDetails_Query(
  $id: ID!
) {
  user(id: $id) {
    email
    is_premium
    is_active
    first_time_user
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_premium",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_active",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "first_time_user",
  "storageKey": null
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Settings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAuthenticated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNavActivated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "selectedSourceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "selectedParentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "treeStates",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "selectedNodeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isParent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFullScreenAddSourceModalActivated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFullSpanSourceSearchModalActivated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAddSourcePageActivated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAddFeedBoxShown",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddSourcePageContainer_UserDetails_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddSourcePageContainer_UserDetails_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "cacheID": "6a6e994fb21940b03b4cf8ea28f02739",
    "id": null,
    "metadata": {},
    "name": "AddSourcePageContainer_UserDetails_Query",
    "operationKind": "query",
    "text": "query AddSourcePageContainer_UserDetails_Query(\n  $id: ID!\n) {\n  user(id: $id) {\n    email\n    is_premium\n    is_active\n    first_time_user\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '31ae15ae9b608f12e566bfb1209a647f';

module.exports = node;
